import { Link, NavLink, useNavigate } from "react-router";
import "./Sidebar.css";
import logo from "../../../assets/images/logo.png";
import allTabs from "./allTabs";
import { useAuth } from "../../../features/auth/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import langSwitcherIcon from "../../../assets/icons/langSwitcher.svg";
import applyLanguageToDocument from "../../../utils/shared/applyLanguageToDocument";

function Sidebar() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { t, i18n } = useTranslation("layout");

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const changeLang = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", lang);
    applyLanguageToDocument(lang);
  };

  return (
    <aside className="side-bar col-auto col-md-3 col-xl-2 px-sm-2 px-0 bg-light">
      <div className="mt-3 d-flex flex-column align-items-center align-items-sm-start px-3 pt-2 min-vh-100">
        <Link
          to="/"
          className="d-flex align-items-center pb-3 mb-md-0 me-md-auto text-decoration-none"
        >
          <span className="sidenav-logo-pic">
            <img loading="lazy" src={logo} alt="Site logo" />
          </span>
        </Link>

        <ul
          className="nav nav-pills flex-column  align-items-center align-items-sm-start"
          id="menu"
        >
          {allTabs.map((tab) => (
            <li key={tab.id} className="nav-item w-100">
              <NavLink
                to={tab.to}
                end
                className={({ isActive }) =>
                  `nav-link  ${isActive ? "active" : ""}`
                }
              >
                <FontAwesomeIcon icon={tab.tabIcon} />
                <p className="ms-1 d-none d-sm-inline">
                  {t(`sidebar.tabs.${tab.id}`)}
                </p>
              </NavLink>
            </li>
          ))}
        </ul>
        <ul
          className="nav nav-pills flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start"
          id="menu"
        >
          <li className="nav-item langSwitcher-item w-100">
            <button
              type="button"
              className="langSwitcher"
              onClick={() => changeLang(i18n.language === "EN" ? "AR" : "EN")}
            >
              <img loading="lazy" src={langSwitcherIcon} alt="" />
              <p>{i18n.language === "EN" ? "AR" : "EN"}</p>
            </button>
          </li>
          <li className="nav-item logout-item w-100">
            <button
              type="button"
              className="btn align-middle text-start"
              onClick={handleLogout}
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" />
              </svg>
              <p className="ms-1 d-none d-sm-inline">{t("sidebar.logout")}</p>
            </button>
          </li>
        </ul>
      </div>
    </aside>
  );
}

export default Sidebar;
